module.exports = __webpack_public_path__ + "static/media/44.01f0f046.jpg";